'use client'

import React, { useEffect, useState } from 'react'
import Contact_form from '../components/forms/Contact_form'
import { useSelector } from 'react-redux'
import Image from 'next/image'

function Contact({ contactData, contactPData }) {
  // const [contactData, setContact] = useState(null);
  const [isMobilescreen, setMobilescreen] = useState(false)

  useEffect(() => {
    // let contactPageData = {};
    // if (contactData == null) {
    //   contactPageData = pageList.find((page) => page.slug == "contact-us");
    //   setContact(contactPageData);
    // }

    if (window.innerWidth < 767) setMobilescreen(true)
  }, [])

  const countryList = useSelector((state) => state.project.countryList)

  // useEffect(() => {
  //   console.log(ContactFrData);
  //   console.log(countryList);
  // }, [ContactFrData]);

  return (
    <>
      {contactPData && contactPData.page_name && (
        <div
          className="reecosys-main-wrapper"
          id="reecosys-main-wrapper"
          // ng-click="country_code_click_false();"
        >
          <div id="reecosys-contact-wrapper" className="relative">
            <section
              className="reecosys-section relative"
              id="reecosys-contact-section-banner"
            >
              <div className="commonpage_banner">
                <div style={{ height: '100%' }} className="relative">
                  <Image
                    priority
                    fill
                    fetchPriority="high"
                    src="/images/banners/contact-us-banner.jpg"
                    alt=""
                  />
                </div>
              </div>
              <div className="black_overlay"></div>
              <div className="banner-text-half">
                <div className="banner-title">
                  <h1 className="white-color">
                    Contact <span className="red-venus-color">Us</span>
                  </h1>
                </div>
              </div>
            </section>

            <section
              className="reecosys-section commonpage_form_section"
              id="reecosys-contact-section-1"
            >
              <div className="container">
                <div className="commonpage_grid content-size-div-padding-top">
                  <div className="inner-flex-commonpage">
                    {contactData.contact_list?.[0].address ? (
                      <div>
                        <div className="content-size-div">
                          <p className="title-color capitalize">Address</p>
                        </div>
                        <div className="content-size-div content-size-div-address-para content-size-div-padding-top">
                          <p>
                            1101, Venus Amadeus, <br />
                            Jodhpur Cross Road, Satellite, <br />
                            Ahmedabad - 380015.
                          </p>
                        </div>
                        <div
                          style={{ margin: '1rem 0' }}
                          className="content-size-div-padding-top"
                        >
                          <div className="flex-row-contact">
                            <div className="flex-row-icon-contact">
                              <img src="/images/icon/call.png" alt="call" />
                            </div>
                            <div className="content-size-div ">
                              <a
                                href="tel:+91-74520-74520"
                                title="+91-74520-74520"
                                aria-label="+91-74520-74520"
                              >
                                <p>74520 74520</p>
                              </a>
                            </div>
                          </div>
                          <div className="flex-row-contact">
                            <div className="flex-row-icon-contact">
                              <img
                                src="/images/icon/email_icon.png"
                                alt="email"
                              />
                            </div>
                            <div className="content-size-div ">
                              <a
                                href="mailto:sales@venusinfrastructure.com"
                                title="sales@venusinfrastructure.com"
                                aria-label="sales@venusinfrastructure.com"
                              >
                                <p>sales@venusinfrastructure.com</p>
                              </a>
                            </div>
                          </div>
                          <div className="flex-row-contact">
                            <div className="flex-row-icon-contact">
                              <img
                                src="/images/icon/email_icon.png"
                                alt="email"
                              />
                            </div>
                            <div className="content-size-div ">
                              <a
                                href="mailto:coordination@venusinfrastructure.com"
                                title="coordination@venusinfrastructure.com"
                                aria-label="coordination@venusinfrastructure.com"
                              >
                                <p>coordination@venusinfrastructure.com</p>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="contact-us-iframe">
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d17467.684407324563!2d72.523320465784!3d23.019063747004417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84ce70d00001%3A0xcaf6e72baf055df8!2sVenus%20Infrastructure%20-%20Corporate%20Office!5e0!3m2!1sen!2sin!4v1718618044747!5m2!1sen!2sin"
                            style={{
                              border: 0,
                              border: 0,
                              width: '100%',
                              height: '100%',
                              margin: '1rem auto',
                              display: 'block'
                            }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                          ></iframe>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="">
                    <Contact_form
                      countryList={countryList}
                      departmentList={contactData.contact_list?.[0].details}
                    />
                    {/* <div ng-include='"templates/forms/contact_form.html"'></div> */}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
    </>
  )
}

export default Contact
